import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right_arrow",
  "use": "icon-right_arrow-usage",
  "viewBox": "0 0 28.245 41.58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.245 41.58\" id=\"icon-right_arrow\"><defs><style>#icon-right_arrow .a{fill:#d5d5d5;}</style></defs><path class=\"a\" d=\"M19.179,2.188a2,2,0,0,1,3.221,0L39.235,25.059a2,2,0,0,1-1.611,3.186H3.956a2,2,0,0,1-1.611-3.186Z\" transform=\"translate(28.245) rotate(90)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol